import { createSlice } from "@reduxjs/toolkit";

const paymentModeSlice = createSlice({
    name:'paymentmode',
    initialState:{
        paymentmode:[]
    },
    reducers: {
        addPaymentMode : (state,action) => {
            state.paymentmode = [...state.paymentmode,action.payload]
        },
        // removeOccupation(){
        //     return state.occupation.filter((item)=> item.id != action.payload);
        // }
    }
});

export const { addPaymentMode } = paymentModeSlice.actions;
export default paymentModeSlice.reducer;